import { render, staticRenderFns } from "./main-visual-scrolldown.vue?vue&type=template&id=c6a2561a&scoped=true"
import script from "./main-visual-scrolldown.vue?vue&type=script&lang=js"
export * from "./main-visual-scrolldown.vue?vue&type=script&lang=js"
import style0 from "./main-visual-scrolldown.vue?vue&type=style&index=0&id=c6a2561a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a2561a",
  null
  
)

export default component.exports